/**
 * Brand visual identity tokens for the "outside the app" screens
 * (login, cadastro, recuperação de senha, 2FA, seleção de plano, checkout).
 *
 * Os painéis de hero usam o verde-petróleo (teal) do Librattum. Sobre o verde
 * escuro a logo é exibida em branco/amarelo (logoSidebar) para bom contraste.
 * O amarelo (#F5B322) permanece como detalhe discreto (botões de ação, ícones
 * e destaques pontuais).
 */

/**
 * Gradiente verde-petróleo usado nos painéis de hero/cabeçalho.
 * Escuro no topo → mais claro embaixo, p/ dar profundidade e deixar a logo
 * respirar bem na parte de cima.
 */
export const BRAND_HERO_GRADIENT =
  'linear-gradient(160deg, #083A2E 0%, #0B4A3B 45%, #0F6E5A 100%)';

/** Verde-petróleo sólido para textos/links/acentos sobre fundo claro. */
export const BRAND_TEAL = '#0F6E5A';

/** Amarelo de acento (mantido da identidade anterior, uso discreto). */
export const BRAND_ACCENT = '#F5B322';
